import React from "react";
import useCompanyAuth from "hooks/useCompanyAuth";

export default function CompanyDashboard() {
  const { companyId, companyName, maxusers, acctype, subscription_type, plantype } = useCompanyAuth();

  return (
    <div>
      <div className="md:flex md:items-center md:justify-between mb-6">
        <div className="min-w-0 flex-1">
          <h2 className="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
            Company Dashboard
          </h2>
          <p className="mt-1 text-sm text-gray-500">
            Manage your company users, preferences, and settings
          </p>
        </div>
      </div>

      {/* Company Info Cards */}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 mb-8">
        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
          <dt className="truncate text-sm font-medium text-gray-500">Company ID</dt>
          <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
            {companyId}
          </dd>
        </div>

        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
          <dt className="truncate text-sm font-medium text-gray-500">Max Users</dt>
          <dd className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
            {maxusers}
          </dd>
        </div>

        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
          <dt className="truncate text-sm font-medium text-gray-500">Account Type</dt>
          <dd className="mt-1 text-xl font-semibold tracking-tight text-gray-900">
            {acctype === 1 ? "Trader" : acctype === 2 ? "Agent" : "Unknown"}
          </dd>
        </div>

        <div className="overflow-hidden rounded-lg bg-white px-4 py-5 shadow sm:p-6">
          <dt className="truncate text-sm font-medium text-gray-500">Subscription</dt>
          <dd className="mt-1 text-xl font-semibold tracking-tight text-gray-900">
            {subscription_type} {plantype === 1 ? "(Premium)" : ""}
          </dd>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="rounded-lg bg-gray-50 px-6 py-8 mb-8">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <a
            href="/company/users"
            className="block rounded-lg bg-white px-4 py-3 text-center shadow hover:bg-gray-50 transition"
          >
            <div className="text-sm font-medium text-gray-900">Manage Users</div>
            <div className="mt-1 text-xs text-gray-500">Add, edit, or remove users</div>
          </a>
          <a
            href="/company/godowns"
            className="block rounded-lg bg-white px-4 py-3 text-center shadow hover:bg-gray-50 transition"
          >
            <div className="text-sm font-medium text-gray-900">Godown Management</div>
            <div className="mt-1 text-xs text-gray-500">Manage warehouse locations</div>
          </a>
          <a
            href="/company/preferences"
            className="block rounded-lg bg-white px-4 py-3 text-center shadow hover:bg-gray-50 transition"
          >
            <div className="text-sm font-medium text-gray-900">Preferences</div>
            <div className="mt-1 text-xs text-gray-500">Configure company settings</div>
          </a>
          <a
            href="/company/backup"
            className="block rounded-lg bg-white px-4 py-3 text-center shadow hover:bg-gray-50 transition"
          >
            <div className="text-sm font-medium text-gray-900">Database Backup</div>
            <div className="mt-1 text-xs text-gray-500">Download company data</div>
          </a>
        </div>
      </div>

      {/* Welcome Message */}
      <div className="rounded-lg bg-indigo-50 px-6 py-8">
        <h3 className="text-lg font-semibold text-indigo-900 mb-2">
          Welcome to {companyName} Portal
        </h3>
        <p className="text-sm text-indigo-700">
          Use this portal to manage your company's users, configure preferences, and maintain your system settings.
          Navigate using the sidebar menu to access different sections.
        </p>
      </div>
    </div>
  );
}

